import React from 'react';
import { CardSelected } from './CardSelected';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { transitionAnimation } from 'libs/growth-platform-brand-system-v2/src/components/Card/logic';
import { CardProps } from 'libs/growth-platform-brand-system-v2/src/components/Card';

export const Card = ({
  type,
  className,
  classNameWrapper,
  activeHover = false,
  as: Component = undefined,
  logo,
  logoPosition,
  title,
  subtitle,
  text,
  name,
  jobPosition,
  companyDescription,
  ctaButton,
  image,
  imagePosition,
  capsText,
  cardsBackgroundColor,
  disableBorder,
  cardAs,
  children,
  ...props
}: CardProps) => {
  const classNameComponent = classNames(
    'Card',
    className,
    activeHover && 'hover:bg-blue-51 group-two',
    transitionAnimation,
  );

  const componentProps = {
    type,
    className: classNameComponent,
    activeHover,
    logo,
    logoPosition,
    title,
    subtitle,
    text,
    name,
    jobPosition,
    companyDescription,
    ctaButton,
    image,
    imagePosition,
    capsText,
    cardsBackgroundColor,
    disableBorder,
    as: cardAs,
    ...props,
  };

  return Component ? (
    <Component
      {...props}
      className={classNames(classNameWrapper, 'w-full h-full')}
    >
      <CardSelected {...componentProps}>{children}</CardSelected>
    </Component>
  ) : (
    <CardSelected {...componentProps}>{children}</CardSelected>
  );
};
